/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountSettings} from '../models/AccountSettings';
import type {Error} from '../models/Error';

export interface GetAccountSettings$Request {
    accountId: number;
}

export interface GetAccountSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountSettingsRequest = createAction<PayloadData<void, GetAccountSettings$Request>>('GET_ACCOUNT_SETTINGS__GET_ACCOUNT_SETTINGS__REQUEST');
export const getAccountSettingsSuccess = createAction<PayloadData<AccountSettings, GetAccountSettings$Request>>('GET_ACCOUNT_SETTINGS__GET_ACCOUNT_SETTINGS__SUCCESS');
export const getAccountSettingsFailure = createAction<PayloadData<Error, GetAccountSettings$Request, true>>('GET_ACCOUNT_SETTINGS__GET_ACCOUNT_SETTINGS__FAILURE');

export const getAccountSettingsActions = [
    getAccountSettingsRequest,
    getAccountSettingsSuccess,
    getAccountSettingsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountSettings = (meta: GetAccountSettings$Request, config?: GetAccountSettings$Config) => {
    return {
        CALL_API: {
            types: getAccountSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

